import { render, staticRenderFns } from "./ResumePerProductsChart.vue?vue&type=template&id=5e016b04&scoped=true"
import script from "./ResumePerProductsChart.vue?vue&type=script&lang=js"
export * from "./ResumePerProductsChart.vue?vue&type=script&lang=js"
import style0 from "./ResumePerProductsChart.vue?vue&type=style&index=0&id=5e016b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e016b04",
  null
  
)

export default component.exports